// Copyright (c) Zammo Inc.
import React from 'react';
import styled from 'styled-components';
import ReactModal from 'react-modal';

import './Modal.css';

const CloseButton = styled.button`
  position: absolute;
  right: 20px;
  top: 20px;
  background-color: transparent;
  border: 0;
  padding: 0;
  margin: 0;
  span {
    font-size: 60px;
    font-weight: 100;
    min-height: 1px;
    line-height: 20px;
  }
`;

const Container = styled.div`
  position: relative;
  padding: 3rem 2rem;
`;

interface Props extends ReactModal.Props {
  containerStyles?: React.CSSProperties;
  children: React.ReactNode;
  onClose: () => void;
  showCloseButton?: boolean;
}

function Modal({ children, containerStyles, showCloseButton, onClose, ...props }: Props) {
  return (
    <ReactModal className="ZammoModal" {...props}>
      <Container style={containerStyles}>
        {showCloseButton && (
          <CloseButton type="button" aria-label="Close" onClick={onClose}>
            <span aria-hidden="true">&times;</span>
          </CloseButton>
        )}
        {children}
      </Container>
    </ReactModal>
  );
}

export default Modal;
